// Module
var code = "<div *ngIf=\"loading > 0\" class=\"load-bar\"> <div class=\"bar\"></div> <div class=\"bar\"></div> <div class=\"bar\"></div> <div class=\"bar\"></div> </div>";
// Exports
module.exports = code;